import React, { useEffect } from 'react'
import View from './view.js'
import { useDataChange } from 'Simple/Data.js'

let DEFAULT_FORM = {
  board_id: null,
  stage_id: null,
  assignee_id: null,
  priority: 'medium',
  patient_id: null,
  title: '',
  description: null,
  tags: [],
  action_options: [{ id: 'letter', text: 'Generate letter' }],
  action: {
    document_template: null,
    id: null,
  },
}

export default function TasksCreateForm(props) {
  let change = useDataChange({
    context: 'form',
    viewPath: props.viewPath,
  })

  useEffect(() => {
    change({
      ...DEFAULT_FORM,
      ...(props.value || {}),
      ...(props.forceAction ? { action: props.forceAction } : {}),
      ...(props.forcePatient ? { patient: props.forcePatient } : {}),
    })
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return <View {...props} />
}
